import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ScheduledMonitorsRepositoryService } from '../../../services/scheduled-monitors/scheduled-monitors-repository.service';
import { AutomationMonitorComponent } from '../base-monitor-component';
import { AutomationMonitor, ConfirmDialogComponent } from 'reg-hub-common';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-scheduled-monitors',
    templateUrl: './scheduled-monitors.component.html',
    styleUrls: ['./scheduled-monitors.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScheduledMonitorsComponent extends AutomationMonitorComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);

  protected displayedColumns = [
    'icon',
    'automationName',
    'scheduledFrequency',
    'warningFrequency',
    'lastSuccessfulRunDate',
    'delete'
  ]

  constructor(private scheduledMonitorService: ScheduledMonitorsRepositoryService,
    private dialog: MatDialog) { 
    super(scheduledMonitorService);
  }

  ngOnInit(): void {
    // This table loads its own data so the dashboard's page-wide spinner
    // doesn't wait on a request only this table needs.
    this.repo.getFirstPageSubscribable().subscribe({
      error: () => {
        //Handle Error
      }
    });
  }

  onDeleteMonitor(automationMonitor: AutomationMonitor) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { 
        title: this.transloco.translate('scheduledMonitors.confirmDeleteThisAutomationMonitor'), 
        confirmationPrompt: "",
        positiveResponseLabel: this.transloco.translate('common.buttons.delete'),
        negativeResponseLabel: this.transloco.translate('common.buttons.cancel')
      },
      minWidth: '800px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // submission is confirmed, submit order
        this.deleteAutomationMonitor(automationMonitor);
      }
    });
  }

  deleteAutomationMonitor(automationMonitor: AutomationMonitor) {
    this.scheduledMonitorService.deleteMonitor(automationMonitor.id)
    .subscribe({
      next: () => {
        this.repo.refresh();
      },
      error: () => {
        //Handle Error
      }
    });
  }
}
